var _dec, _class, _TopNavBarBreadcrumb, _IconHamburgerLine;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Children, Component } from 'react';
import { allowedProps } from "./props.js";
import TopNavBar from "../index.js";
import { withStyle } from '@instructure/emotion';
import generateStyle from "../TopNavBarBreadcrumb/styles.js";
import { IconArrowOpenStartLine, IconHamburgerLine } from '@instructure/ui-icons';
import TopNavBarContext from "../TopNavBarContext.js";
import { error } from '@instructure/console';
import { Link } from '@instructure/ui-link';

/**
---
parent: TopNavBar
id: TopNavBar.Breadcrumb
---
@module TopNavBarBreadcrumb
 **/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let TopNavBarBreadcrumb = (_dec = withStyle(generateStyle, null), _dec(_class = (_TopNavBarBreadcrumb = class TopNavBarBreadcrumb extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props, {
      inverseColor: this.context.inverseColor
    });
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2, {
      inverseColor: this.context.inverseColor
    });
  }
  renderMenu() {
    var _this$props$styles;
    const onClick = this.props.onClick;
    return _jsx("div", {
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.icon,
      children: _jsx(TopNavBar.Item, {
        id: "iconItem",
        variant: "icon",
        renderIcon: _IconHamburgerLine || (_IconHamburgerLine = _jsx(IconHamburgerLine, {})),
        onClick: onClick,
        children: "Hamburger menu"
      })
    });
  }
  render() {
    const _this$props3 = this.props,
      children = _this$props3.children,
      styles = _this$props3.styles;
    if (!this.context.inverseColor) {
      error(false, `[TopNavBarBreadcrumb] If the inverseColor prop is not set to true, TopNavBarBreadcrumb fails to render.`);
    }
    const breadcrumbElement = Children.toArray(children)[0];
    const breadCrumbLinks = breadcrumbElement.props.children;
    const lastButOneLink = Children.toArray(breadCrumbLinks)[Children.count(breadCrumbLinks) - 2];
    return this.context.inverseColor && (this.context.layout === 'desktop' ? _jsxs("div", {
      ref: this.handleRef,
      css: styles === null || styles === void 0 ? void 0 : styles.topNavBarBreadcrumb,
      "data-cid": "TopNavBarBreadcrumb",
      children: [_jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.iconContainer,
        children: this.renderMenu()
      }), _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.breadcrumbContainer,
        children: children
      })]
    }) : _jsx("div", {
      ref: this.handleRef,
      css: styles === null || styles === void 0 ? void 0 : styles.topNavBarBreadcrumb,
      "data-cid": "TopNavBarBreadcrumb",
      children: _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.linkContainer,
        children: lastButOneLink && _jsx(Link, {
          href: lastButOneLink.props.href,
          isWithinText: false,
          renderIcon: IconArrowOpenStartLine,
          children: lastButOneLink.props.children
        })
      })
    }));
  }
}, _TopNavBarBreadcrumb.displayName = "TopNavBarBreadcrumb", _TopNavBarBreadcrumb.allowedProps = allowedProps, _TopNavBarBreadcrumb.defaultProps = {}, _TopNavBarBreadcrumb.contextType = TopNavBarContext, _TopNavBarBreadcrumb)) || _class);
export { TopNavBarBreadcrumb };
export default TopNavBarBreadcrumb;